export default "__VITE_ASSET__CGQoaO7$__"